import { useEffect, useRef, useState } from "react";
import { ILogin } from "../../../models/Login";
import { Fetch } from "../../../shared/Fetch";
import { Dialog } from "primereact/dialog";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { IUserMast } from "../../../models/UserMast";

interface ISalesEfficiency {
    login_ID?: number,
    sales?: string,
    branchName?: string,
    noOfReq?: number,
    noOfSub?: number,
    noOfSubPV?: number,
    noOfSubClient?: number,
    noOfSubRejSales?: number,
    noOfSubRejPV?: number,
    noOfSubRejClient?: number,
    noOfECI?: number,
    noStatusNotChange?: number,
    served?: number,
    unserved?: number,
    per?: number,
    noOfContact?: number,
}

interface IProps {
    open: boolean,
    hide: () => void,
    toast: any,
    isManager: number,
    companyname: string,
    recruiter: number,
}

export const VendorCompanyHistoryTable = (props: IProps) => {
    const [tableData, setTableData] = useState({ tableData: [], loading: true } as { tableData: ISalesEfficiency[], loading: boolean });
    const dt = useRef<any>(null);
    // const [isSalesManager, setIsSalesManager] = useState<boolean>(false);

    const loadTableData = async (filters: any) => {
        setTableData({ tableData: tableData.tableData, loading: true });
        const response = await Fetch("SubVendorPerformanceReports/forsales", "GET", null, `filter=${JSON.stringify(filters)}`, null);
        if (response) {
            const data: Array<any> = await response.json();
            console.log(data);
            setTableData({ tableData: data, loading: false });
        }
    };

    useEffect(() => {
        if (props.open === true && props.isManager != 0) {

            // let filter = {
            //     fromDate: null,
            //     toDate: null,
            //     company: null,
            //     branch: null,
            //     team: null,
            //     salesManager: props.isManager,
            //     isFilter: 1,
            //     requirement_Type: null,
            //     user_Status: null
            // };
            let filter = {
                from_Date: null,
                to_Date: null,
                sub_Vendor: props.companyname,
                company: 0,
                branch: 0,
                recruiter: props.recruiter,
                isFilter: 1
                // recruiter: null,
            };

            loadTableData(filter);
        };
    }, [props.open]);

    return (
        <>
            <Dialog visible={props.open} style={{ width: '80vw' }} header="Employer's Efficiency details" footer={<></>} className="p-fluid" draggable={false} onHide={() => props.hide()}>
                <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0", marginTop: "5px" }}
                    ref={dt} size="small" stripedRows showGridlines responsiveLayout="scroll"
                    // exportFilename={format(new Date(), 'dd-MM-yyyy hh_mm_ss a').toUpperCase()}
                    value={tableData.tableData}
                    emptyMessage="No Requirements found."
                    header={"Table"}
                    loading={tableData.loading}

                >
                    <Column header="SN." body={(data, options) => options.rowIndex + 1} style={{ maxWidth: '4rem' }} />
                    <Column field="vendor_Company_Name" header="Sub Vendor" sortable />
                    <Column field="sub" header="Sub"  />
                    <Column field="rejected_Sales" header="Rejected Sales" sortable />
                    <Column field="rejected_PV" header="Rejected PV" />
                    <Column field="subEnd" header="Sub End Client" />
                    <Column field="eci" header="ECI" />
                    <Column field="po" header="PO" />
                </DataTable>
            </Dialog>
        </>
    );
}